var map = {
	"./ABOCCNBJXXX.png": "08cd",
	"./BEASCNSHXXX.png": "5297",
	"./BINHCN2NXXX.png": "90db",
	"./BJCNCNBJXXX.png": "a03e",
	"./BKCHCNBJXXX.png": "6fab",
	"./BOJSCNBNXXX.png": "ae90",
	"./BOSHCNSHXXX.png": "925e",
	"./CBOCCNBCXXX.png": "2750",
	"./CHBHCNBTXXX.png": "88d4",
	"./CIBKCNBJXXX.png": "b230",
	"./CMBCCNBSXXX.png": "1462",
	"./COMMCNSHXXX.png": "0daa",
	"./CQCBANK.png": "b75d",
	"./CSCBBANK.png": "db23",
	"./EVERCNBJXXX.png": "aed7",
	"./FJIBCNBAXXX.png": "55ae",
	"./GDBKCN22XXX.png": "c956",
	"./HENGFENGBANK.png": "cf34",
	"./HFCBCNSHXXX.png": "dc45",
	"./HXBKCNBJXXX.png": "dcfb",
	"./HZCBCN2HXXX.png": "c486",
	"./ICBKCNBJXXX.png": "4a35",
	"./MSBCCNBJXXX.png": "8e83",
	"./NJCBCNBNXXX.png": "207f",
	"./PCBCCNBJXXX.png": "1fdf",
	"./PSBCCNBJXXX.png": "1bb6",
	"./QCCBCNBQ.png": "56b1",
	"./SHRCCNSHXXX.png": "6e0c",
	"./SPDBCNSHXXX.png": "337e",
	"./SZDBCNBSXXX.png": "3c89",
	"./ZJCBCN2NXXX.png": "6c4c",
	"./bank.png": "fcf0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db91";